import React from 'react';

const Footer = () => {
    return (
     
        <footer className="px-10 pb-24 text-center">Designed & Built by Rubayed 2023</footer>
    );
};

export default Footer;